module.exports = __webpack_public_path__ + "img/wtiogomark_ra.3b43dfc8.png";